import React from 'react'

import CubeReportAccessFiltersContext from 'cube/contexts/cubeReportAccessFilters.context'
import useCubeReportAccessFilters from 'cube/hooks/useCubeReportAccessFilters.hook'

import { Flex, SimpleGrid } from '@driftt/dds'

import {
  ConversationCountKPICard,
  ConversationStartedFromTable,
  MedianConversationLengthKPICard,
} from 'components/conversation'
import { ConversationCountLineChart } from 'components/conversation/ConversationCountsLineChart'
import { ConversationHeatMapChart } from 'components/conversation/ConversationHeatMapChart'
import { ConversationMedianTimeChartBeta } from 'components/conversation/ConversationMedianTimeChartBeta'
import { ConversationTagsTable } from 'components/conversation/ConversationTagsTable'
import { withCubeReportsLayout } from 'layouts/CubeReportsLayout'
import { ReportPage } from 'types/pages'

const ConversationsReport = () => {
  /**
   * Note -- Access filters are used to manage a limited access view for this report.
   * These filters should be applied to all queries if the current user only has access to their conversations (!userHasOrgConversationReports). For ex, Sales Reps.
   */
  const { accessFilters } = useCubeReportAccessFilters()
  return (
    <CubeReportAccessFiltersContext.Provider
      value={{
        accessFilters,
      }}
    >
      <Flex direction={'column'} gap={3} fullWidth fullHeight>
        <SimpleGrid fullWidth columns={2} gap={3}>
          <ConversationCountKPICard />
          <MedianConversationLengthKPICard />
          <ConversationCountLineChart />
          <ConversationMedianTimeChartBeta />
          <ConversationHeatMapChart />
          <ConversationStartedFromTable />
          <ConversationTagsTable />
        </SimpleGrid>
      </Flex>
    </CubeReportAccessFiltersContext.Provider>
  )
}

export default withCubeReportsLayout(
  ReportPage.Conversation,
  true,
  true
)(ConversationsReport)
